export class PersonaExpuesta {

    model = {
        id: {
            value: null,
            header: 'Código',
        },
        origen_fondo: {
            value: null,
            header: 'Los fondos y/o bienes a transferir al fideicomiso son propios o de terceros?',
            required: 'Seleccione alguna opción'
        },
        fondo_detalle: {
            value: '',
            header: '(En caso de personas sin ingresos o que manejan fondos de terceros, indicar los siguintes datos de la persona que aportará los fondos: nombres completos, número de identificación, correo electrónico y número de teléfono.)',
            maxLength: 'Máximo 250 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 250,
            min: 4,
        },
        pep: {
            value: null,
            export: false,
            header: 'Declaro que me encuentro ejerciendo y/o he ejercido hace un (1) año cargos públicos:',
            required: 'Seleccione una opción'
        },
        cargo_pep: {
            value: '',
            export: false,
            header: 'Cargo desempeñado:',
            required: 'Cargo es requerido',
            min: 2,
            max: 200,
            minLength: 'Mínimo 2 caracteres',
            maxLength: 'Máximo 200 caracteres',
        },
        tiempo_pep: {
            value: '',
            export: false,
            header: 'Tiempo en el cargo:',
            required: 'Tiempo es requerido',
            min: 2,
            max: 100,
            minLength: 'Mínimo 2 caracteres',
            maxLength: 'Máximo 100 caracteres',
        },
        relacion_pep: {
            value: null,
            export: false,
            header: 'Declaro que tengo y/o he tenido hace (1) año relación con personas expuestas políticamente (pep) hasta el cuarto grado de consanguinidad y segundo de afinidad:',
            required: 'Seleccione una opción'
        },
        nombre_pep: {
            value: '',
            export: false,
            header: 'Nombre completo de la persona PEP:',
            required: 'Nombre es requerido',
            min: 4,
            max: 200,
            minLength: 'Mínimo 4 caracteres',
            maxLength: 'Máximo 200 caracteres',
        },
        cargo_nombre_pep: {
            value: '',
            export: false,
            header: 'Cargo de la persona PEP:',
            required: 'Cargo es requerido',
            min: 2,
            max: 200,
            minLength: 'Mínimo 2 caracteres',
            maxLength: 'Máximo 200 caracteres',
        },
        tiempo_nombre_pep: {
            value: '',
            export: false,
            header: 'Tiempo en el cargo:',
            required: 'Tiempo es requerido',
            min: 2,
            max: 100,
            minLength: 'Mínimo 2 caracteres',
            maxLength: 'Máximo 100 caracteres',
        },
        tipo_relacion_pep: {
            value: '',
            export: false,
            header: 'Tipo de relación con la PEP:',
            required: 'Tipo de relación es requerido',
            min: 2,
            max: 100,
            minLength: 'Mínimo 2 caracteres',
            maxLength: 'Máximo 100 caracteres',
        },
        eeuu_fin_fiscal: {
            value: null,
            export: false,
            header: '¿Es una persona estadounidense para fines fiscales?',
            required: 'Seleccione una opción'
        },
        eeuu_identificacion: {
            value: '',
            header: 'No. de Identificación de Estados Unidos de América:',
            required: 'Identificación es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
        },
        extranjero_fin_fiscal: {
            value: null,
            export: false,
            header: '¿La persona es residente de cualquier otro pais distinto de Estados Unidos de América o Ecuador, para fines fiscales?',
            required: 'Seleccione una opción'
        },
        extranjero_identificacion: {
            value: '',
            header: 'No. de Identificación del contribuyente.',
            required: 'Identificación es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
        },
        enf_inversion: {
            value: null,
            export: false,
            header: '¿Es un Constituyente / Beneficiario de un Fideicomiso que es una Entidad No Financiera (ENF) Pasiva o una Entidad de Inversión residentes en el exterior y administrada por otra Institución Financiera.?',
            required: 'Seleccione una opción'
        }
    }
    msgOrigen = <><p style={{ textAlign: 'justify' }}>1.Todos los bienes y/o fondos que se entregarán o aportarán para la conformación o integración de cualquier negocio fiduciario o fondos de
        inversión a ser administrado por Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A., tienen orígen lícito y no provienen, ni provendrán y no están ni estarán relacionados
        directa o indirectamente con actos tipificados como delito o prohibidos por la Ley Orgánica de Prevención Integral del Fenómeno Socio Económico de las Drogas y de Regulación y Control
        del Uso de Sustancias Catalogadas Sujetas A Fiscalización, en la Ley Orgánica de Prevención, Detección y Erradicación del Delito de Lavado de Activos y del Financiamiento de Delitos y
        en general cualquier actividad considerada como ilícita por la legislación ecuatoriana.
        2. La actividad económica que realiza la compañía es permitida por las leyes Ecuatorianas y no son operaciones/transacciones económicas inusuales e injustificadas acorde a la Ley
        Orgánica de Prevención, Detección y Erradicación del Delito de Lavado de Activos y del Financiamiento de Delitos.
        3.Declaro que toda la información proporcionada a la fiduciaria, especialmente la proporcionada conforme a las políticas de conocimiento del cliente, es verdadera y ratifico la
        facultad que la fiduciaria tiene para verificar dicha información.
        4. No admitiré que terceros efectúen pagos o inversiones a nombre de la compañía, provenientes de actividades ilícitas ni se efectuarán transacciones destinadas a tales actividades
        o a favor de personas relacionadas con las mismas.
        5. Autorizo a la FIDUCIARIA para que en el caso de infracción de cualquiera de las declaraciones o compromisos constantes de este instrumento, pueda iniciar el proceso de
        terminación y liquidación del negocio fiduciario respectivo, eximiendo a la FIDUCIARIA de toda responsabilidad que se derive por información errónea, falsa o inexacta que nosotros
        hubiéramos proporcionado en este documento o de la violación al mismo.</p></>;

    msgAcceso = <><p style={{ textAlign: 'justify' }}>Autorizo de manera expresa a Trust Fiduciaria Administradora de Fondos y Fideicomisos S.A. a verificar por los medios que
        estime pertinentes los datos aquí proporcionados. Así mismo autorizo para que a través de los datos constantes en el Registro Crediticio, Burós de información y otras
        fuentes, puedan acceder a la obtención de información del suscrito, de mi representada, sobre mi (nuestro) comportamiento crediticio, manejo de mi (s) (nuestras) cuenta
        (s) corriente (s), de ahorro, tarjeta (s) de crédito, etcétera, y en general sobre el cumplimiento de mis (nuestras) obligaciones y demás activos, pasivos y datos personales.</p></>;

    msgDeclaracion = <><p>Certifico que la información proporcionada en este formulario es correcta y completa. Autorizo a TRUST FIDUCIARIA ADMINISTRADORA DE FONDOS Y FIDEICOMISOS S.A.
        a proporcionar, directa o indirectamente, la información contenida es este formulario y/o una copia del mismo a cualquier autoridad fiscal pertinente o a cualquier
        parte autorizada para auditar o realizar un control similar de TRUST FIDUCIARIA para fines fiscales; así como, a divulgar a tales autoridades fiscales o parte autorizada
        cualquier información adicional que pudiese poseer TRUST FIDUCIARIA y que es pertinente para mi calificación para cualquier beneficio reclamado con base en esta certificación.
        Acepto que la información contenida en este formulario y la información relacionada con mis cuentas en TRUST FIDUCIARIA (incluso la información sobre los saldos de cuentas y
        pagos recibidos) se notifique a las autoridades fiscales pertinentes y, que estas autoridades, proporcionen esta información a cualquier otro país enumerado en la lista anterior,
        como a un país en el cual soy residente para fines fiscales. Me comprometo a avisar inmediatamente a TRUST FIDUCIARIA sobre cualquier cambio en las circunstancias que motive que
        la información contenida en este documento sea incorrecta y a proporcionar a TRUST FIDUCIARIA un formulario actualizado y apropiado de Auto-certificación de Residencia Fiscal en
        un plazo de 30 días a partir de la fecha de cambio de circunstancias.</p></>

    msgTratamientoDatos = <>
        <ol style={{ paddingLeft: "13px", }}>
            <li>El Responsable de los Datos Personales ha puesto en mi conocimiento su Política de Tratamiento de Datos Personales, la misma que me ha sido entregada y que consta en su página web. En ella constan los principios, cuidados y derechos respecto al tratamiento de mis datos personales.</li>
            <br />
            <li>De conformidad con el art. 8 de la Ley Orgánica de Protección de Datos Personales y art. 5 de su Reglamento, con la suscripción del presente formulario, consiento de manera libre, previa, expresa, voluntaria, y debidamente informada al Responsable de los Datos Personales, para que realice el tratamiento de mis datos personales en calidad de responsable. Entiendo que mis datos personales podrán ser compartidos con terceros, en concordancia con las disposiciones legales.</li>
            <br />
            <li>El Responsable de los Datos Personales declara que el tratamiento de datos personales se realizará dentro de los límites y de conformidad y con fundamento en lo dispuesto en el Art. 66 nº 19 de la Constitución de la República, la Ley Orgánica de Prevención, Detección y Combate del Delito de Lavado de Activos y de la Financiación de Otros Delitos y la LOPDP. El Responsable tratará mis datos personales con reserva y ha adoptado las medidas técnicas y organizativas necesarias para garantizar su seguridad, integridad y confidencialidad.</li>
            <br />
            <li>Los datos y documentación que aporto mediante el presente formulario son veraces y exactos, y el Responsable podrá efectuar las validaciones que considere pertinentes.</li>
            <br />
            <li>Autorizo al Responsable de los Datos Personales a contactarme y enviarme comunicaciones por cualquier medio, teniendo en consideración la finalidad antes expresada. Asimismo, podré comunicarme con el Responsable en cualquier momento si tengo preguntas o solicitudes sobre el tratamiento de mis datos personales.</li>
        </ol>
    </>;
}
